<template>
  <div
    class="pa-6"
  >
    <v-row>
      <v-spacer />
      <v-col cols="auto">
        <v-btn
          text
          color="primary"
          class="text-none"
          @click="drillModal = true"
        >
          <v-icon
            x-small
            left
          >
            far fa-plus
          </v-icon>
          {{ $t("button.attach_drill") }}
        </v-btn>
      </v-col>
    </v-row>
    <div style="height: 1px">
      <v-progress-linear
        v-if="submitting"
        indeterminate
        color="primary"
        :height="1"
      />
    </div>

    <div v-if="event.drills.length > 0">
      <div
        v-for="(item, index) in event.drills"
        :key="'selected' + item.id + index"
        class="mt-3"
      >
        <v-card
          height="175"
          class="rounded-lg"
          color="grey lighten-5"
          @click="selectedDrill = item; drillInfoModal = true"
        >
          <v-row
            no-gutters
            align="center"
            class="fill-height"
          >
            <v-col
              cols="auto"
              class="mx-3"
            >
              <v-row
                class="flex-column"
              >
                <v-col
                  class="pa-1 mb-1"
                  cols="auto"
                >
                  <v-btn
                    icon
                    :disabled="index === 0"
                    @click.prevent.stop
                    @click="moveUp(item)"
                  >
                    <v-icon small>
                      fa-light fa-chevron-up
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col
                  cols="auto"
                  class="pa-1 mt-1"
                >
                  <v-btn
                    icon
                    :disabled="index === event.drills.length - 1"
                    @click.prevent.stop
                    @click="moveDown(item)"
                  >
                    <v-icon small>
                      fa-light fa-chevron-down
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="5">
              <v-img
                class="rounded"
                :src="item.preview"
              />
            </v-col>
            <v-col class="fill-height">
              <v-row
                class="flex-column pa-4"
                no-gutters
              >
                <v-col
                  class="mb-3"
                >
                  <v-row no-gutters>
                    <v-col>
                      <span
                        class="text-subtitle-2 font-weight-bold"
                        style="-webkit-line-clamp: 2; -webkit-box-orient: vertical; display: -webkit-box; overflow: hidden; width: 100%"
                      >{{ item.name }}</span>
                    </v-col>
                    <v-col
                      cols="auto"
                    >
                      <v-btn
                        icon
                        @click.prevent.stop
                        @click="removeDrill(item)"
                      >
                        <v-icon small>
                          far fa-times
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <span
                    class="text-body-2"
                    style="-webkit-line-clamp: 5; -webkit-box-orient: vertical; display: -webkit-box; overflow: hidden; width: 100%"
                  >{{ item.description }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>

    <v-row
      v-else
      justify="center"
    >
      <v-col
        cols="auto"
        class="grey--text lighten-2"
      >
        {{ $t("event_details.drills.no_drills") }}
      </v-col>
    </v-row>

    <card-dialog
      v-model="drillModal"
      :title="$t('card_title.attach_drill')"
      fullscreen
    >
      <v-card-text>
        <drill-list-view
          :attach-mode="true"
          @attach="handleAttach"
        />
      </v-card-text>
    </card-dialog>

    <card-dialog
      :key="'Edit drill' + componentKey"
      v-model="editDrill"
      :title="$t('card_title.drill.edit')"
      :scrollable="false"
      fullscreen
      persistent
    >
      <v-card-text>
        <div
          style="height: 2px"
        >
          <v-progress-linear
            v-if="submitting"
            indeterminate
            color="primary"
            :height="2"
          />
        </div>
        <HomeView
          :drill="selectedDrill"
          :sport="user.sport.name"
          :players="players.data"
          :teams="teams"
          @save="handleDrillEdit"
        />
      </v-card-text>
    </card-dialog>

    <card-dialog
      v-if="selectedDrill"
      v-model="drillInfoModal"
      :scrollable="false"
      :title="$t('card_title.drill.info')"
      max-width="1200px"
      @close="selectedDrill = null"
    >
      <v-card-text>
        <v-row
          class="mt-2"
        >
          <v-col
            cols="8"
            align-self="center"
          >
            <v-img
              v-if="selectedDrill.preview"
              id="drill_preview"
              class="rounded-xl fa-border"
              :src="selectedDrill.preview"
            />
            <v-img
              v-else
              height="450px"
              class="rounded-xl fa-border"
            >
              <template v-slot:placeholder>
                <v-row
                  no-gutters
                  align="center"
                  justify="center"
                  class="fill-height"
                >
                  <v-col cols="auto">
                    <v-icon x-large>
                      fal fa-court-sport
                    </v-icon>
                  </v-col>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col>
            <v-row
              class="flex-column"
              style="height: 100%;"
            >
              <v-col cols="auto">
                <v-row no-gutters>
                  <v-col>
                    <span class="text--black text-h6">
                      {{ selectedDrill.name }}
                    </span>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      text
                      small
                      color="primary"
                      class="text-none"
                      @click="drillInfoModal = false; editDrill = true"
                    >
                      <v-icon
                        left
                        small
                      >
                        far fa-pen
                      </v-icon>
                      {{ $t("button.edit") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="auto">
                <span class="text--black text-subtitle-1">
                  {{ selectedDrill.description }}
                </span>
              </v-col>
              <v-spacer />
              <v-col cols="auto">
                <v-row>
                  <v-col>
                    <span
                      v-if="selectedDrill.coach"
                      class="text--black text-subtitle-1"
                    >
                      {{ $t("drill_info.dialog.made_by") }} {{ selectedDrill.coach.first_name }} {{ selectedDrill.coach.last_name }}
                    </span>
                  </v-col>
                  <v-col cols="auto">
                    <span class="text--black text-subtitle-1">
                      {{ $dayjs(selectedDrill.created_at).format('DD.MM.YYYY.') }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </card-dialog>
  </div>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog.vue'
import DrillListView from '@/views/DrillListView.vue'
import { EventApiService, PlayerApiService } from '@/data/services'
import { DrillApiService } from '@/data/services/DrillApiService'
import HomeView from '@ultrax-ai/drill-package'

export default {
  name: 'EventDrill',
  components: {
    DrillListView,
    CardDialog,
    HomeView
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    players: {
      data: [],
      loading: false
    },
    drillModal: false,
    submitting: false,
    componentKey: 1,
    selectedDrill: null,
    drillInfoModal: false,
    editDrill: false
  }),
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    teams() {
      return this.$store.getters[this.$storeGetters.APP_TEAMS]
    }
  },
  watch: {
    editDrill: function (val) {
      if (val) this.componentKey++
    }
  },
  created() {
    this.fetchPlayers()
  },
  methods: {
    async save() {
      try {
        this.submitting = true

        const drills = this.event.drills.map(drill => {
          return {
            drill_id: drill.id,
            order: drill.order
          }
        })

        await EventApiService.attachDrills(this.event.id, drills)
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.drill_attach.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.submitting = false
      }
    },
    async fetchPlayers() {
      try {
        this.players.loading = true

        const resp = await PlayerApiService.getSimpleList({})

        this.players.data = resp.data
      } catch (e) {
        this.players.data = []
      } finally {
        this.players.loading = false
      }
    },
    async handleDrillEdit(saveData) {
      try {
        this.editDrill = false
        this.submitting = true

        const data = {
          name: saveData.name,
          description: saveData.description,
          preview: saveData.preview,
          state: saveData.state,
          coach_id: this.user.coach.id,
          team_ids: saveData.team_ids,
          player_ids: saveData.player_ids,
          is_hidden: true,
          tags: saveData.tags
        }

        const result = await DrillApiService.create(data)

        this.event.drills.splice(this.event.drills.indexOf(this.selectedDrill), 1, result.data)

        this.updateOrder()
        await this.save()
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.drill_save.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.submitting = false
      }
    },
    handleAttach(drill) {
      if (this.event.drills.some(d => d.id === drill.id)) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.drill_attach.already_attached'),
          color: 'warning'
        })
        return
      }

      this.drillModal = false
      drill.order = this.event.drills.length + 1

      this.event.drills.push(drill)

      this.save()
    },
    removeDrill(item) {
      this.event.drills.splice(this.event.drills.indexOf(item), 1)

      this.updateOrder()
      this.save()
    },
    updateOrder() {
      this.event.drills.forEach((drill, index) => {
        drill.order = index + 1
      })
    },
    moveUp(item) {
      const index = this.event.drills.indexOf(item)
      this.swapDrills(index, index - 1)
    },
    moveDown(item) {
      const index = this.event.drills.indexOf(item)
      this.swapDrills(index, index + 1)
    },
    swapDrills(from, to) {
      const temp = this.event.drills[from]
      this.event.drills[from] = this.event.drills[to]
      this.event.drills[to] = temp

      this.updateOrder()
      this.save()
    }
  }
}
</script>
